import { getCompatibleAuthTokenHttp } from 'src/services/utils/enhancedAuthTokenHttp';
import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { MutationFunction } from '@tanstack/react-query';

export interface CreateLoanParams {
  status: string;
  loanNumber: string;
  metadata: {
    loanAmount: string;
    creditScore: string;
    loanOfficer: string;
    loanPurpose: string;
    propertyType: string;
    borrowerLastName: string;
    borrowerMiddleName?: string;
    borrowerFirstName: string;
  };
}

export interface CreateLoanResponse {
  success: boolean;
  message: string;
}

const createLoan: MutationFunction<
  CreateLoanResponse,
  CreateLoanParams
> = async (args) => {
  if (isMockServices()) return await mock(_mockType);

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<CreateLoanResponse>(`/loans`, {
    method: 'POST',
    body: {
      status: args.status,
      loanNumber: args.loanNumber,
      metadata: args.metadata,
    },
  });
  if (response.data) return response.data;
  throw new Error('Failed to create loan');
};

export default createLoan;

const _mockType: CreateLoanResponse = {
  success: true,
  message: 'success',
};
